import { useQuery } from '@tanstack/react-query'
import { helpPoint } from '../index'
import cacheKeys from '../../../../services/cacheKeys'

const useHelpPoint = () => {
  return useQuery({
    queryKey: [cacheKeys.HELP_POINT],
    queryFn: helpPoint,
  })
}
export default useHelpPoint
